module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca8b09aa5dc63a2eefe49951456aa832.png";